import { useCallback, useEffect, useState } from "react";
import { levelsColor } from "./filterSettings";
import { useLanguage } from "../../stores/LanguageStore";
import FilterItem from "./FilterItem";
import FilterItemAdder from "./FilterItemAdder";
import FilterGroupAdder from "./FilterGroupAdder";
import { Box, Group, Stack } from "@mantine/core";
import FilterModeSelector from "./FilterModeSelector";

export const conditionWidth = 360;

let newId = 0;

const FilterBlockChild = ({
  values,
  mode,
  parentMode,
  isLast,
  handleDeleteGroup,
  handleChange,
  itemNumbers,
  fields,
  maxItems,
  getFieldOptionName,
  level = 1,
  disableEdit,
  filterItems,
  pageName,
}) => {
  const lang = useLanguage((s) => s.language);

  const [_mode, _setMode] = useState(mode || "and");

  const onModeChange = (v) => {
    _setMode(v);
  };

  const [items, setItems] = useState(
    values.map((x) => ({ ...x, id: newId++ })) || []
  );

  const addItem = () => {
    const newItem = {
      field_name: fields[0].options[0].id.toString(),
      type: fields[0].options[0]?.type === "number" ? "=" : "contains",
      value: "",
      id: newId++,
    };
    setItems((prev) => [...prev, newItem]);
  };

  const addGroup = () => {
    const newItem = {
      id: newId++,
      mode: "and",
      values: [
        {
          field_name: fields[0].options[0].id.toString(),
          type: fields[0].options[0]?.type === "number" ? "=" : "contains",
          value: "",
        },
      ],
    };
    setItems((prev) => [...prev, newItem]);
  };

  const deleteItem = (id) => {
    setItems((prev) => {
      let newItems = prev.filter((x) => x.id !== id);

      return newItems;
    });
  };

  const deleteGroup = (id) => {
    setItems((prev) => {
      let newItems = prev.filter((x) => x.id !== id);

      return newItems;
    });
  };

  const handleItemChange = useCallback(({ id, field_name, type, value }) => {
    setItems((prev) => {
      let newItems = [...prev];
      let index = newItems.findIndex((x) => x.id === id);

      newItems[index] = {
        field_name: field_name,
        type: type,
        value: value,
        id: id,
      };

      return newItems;
    });
  }, []);

  const handleGroupChange = useCallback((id, newValues) => {
    setItems((prev) => {
      let newItems = [...prev];
      let index = newItems.findIndex((x) => x.id === id);
      newItems[index] = { ...newValues, id: id };

      return newItems;
    });
  }, []);

  useEffect(() => {
    if (handleChange) {
      handleChange({
        mode: _mode,
        values: items,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, _mode]);

  useEffect(() => {
    if (items.length === 0) {
      handleDeleteGroup();
    }
  }, [items]);

  return (
    <Stack pos="relative" pl={54} pt={2}>
      {!isLast && (
        <FilterModeSelector
          onChange={onModeChange}
          value={_mode}
          borderColor={levelsColor[0]}
          disabled={disableEdit}
          level={level}
        />
      )}

      {/* Horizontal line */}
      <Box
        style={{
          position: "absolute",
          top: 18,
          left: 12,
          width: 50,
          height: 0,
          borderTop: "1px solid",
          borderColor: levelsColor[level - 1],
        }}
      />

      <Stack pos="relative" pl={2} gap={"xl"}>
        <div
          style={{
            position: "absolute",
            bottom: 15,
            left: 12,
            width: 0,
            height: "calc(100% - 32px)",
            borderRight: "1px solid",
            borderColor: levelsColor[level],
          }}
        />
        {/* Children goes here */}
        {items.map((x, i) =>
          x?.values ? (
            <FilterBlockChild
              key={x.id}
              fields={fields}
              getFieldOptionName={getFieldOptionName}
              handleChange={(newItems) => handleGroupChange(x.id, newItems)}
              handleDeleteGroup={() => deleteGroup(x.id)}
              values={x.values}
              mode={x.mode}
              isLast={i === items.length - 1}
              parentMode={_mode}
              itemNumbers={itemNumbers}
              maxItems={maxItems}
              level={2}
              filterItems={filterItems}
              pageName={pageName}
              disableEdit={disableEdit}
            />
          ) : (
            <FilterItem
              item={x}
              key={x.id}
              lineColor={levelsColor[level]}
              isLast={i === items.length - 1}
              parentMode={_mode}
              handleDelete={() => deleteItem(x.id)}
              handleChange={(newFilter) =>
                handleItemChange({
                  ...newFilter,
                  id: x.id,
                })
              }
              fields={fields}
              getFieldOptionName={getFieldOptionName}
              filterItems={filterItems}
              levelItems={items}
              pageName={pageName}
              level={level}
              _mode={_mode}
              onModeChange={onModeChange}
              disableEdit={disableEdit}
            />
          )
        )}

        <Stack ml={"sm"} pl={25} pos="relative">
          <div
            style={{
              position: "absolute",
              top: "calc(50% - 2px)",
              left: 0,
              width: 23,
              border: 0,
              borderTop: "1px dashed",
              borderColor: levelsColor[level],
            }}
          />
          <Group>
            {level === 1 && (
              <FilterGroupAdder
                disabled={itemNumbers >= maxItems || disableEdit}
                onClick={addGroup}
                color={levelsColor[level]}
              />
            )}
            <FilterItemAdder
              disabled={itemNumbers >= maxItems || disableEdit}
              onClick={addItem}
              color={levelsColor[level]}
            />
          </Group>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default FilterBlockChild;
